export default __webpack_public_path__ + "img/event-substitution-in.bdfec0e1.svg";